<template lang="pug">
    nuxt-link(
        :to="linkBuilder({ name: 'product', params:{ productLine: listing.productLineSlug}})"
        @click.native="$emit('productClicked')"
        class="cursor-pointer no-underline hover:no-underline"
    )
        //- Image/Bugs
        div(class="relative m-auto text-light text-xs font-bold uppercase text-center")
            div(class="image-background absolute w-full h-full")
            img(
                v-if="listing.image"
                :key="listing.image.key"
                v-bind="imgAttrs"
                width="341"
                height="256"
                :alt="listing.image.title || ''"
                class="w-full rounded"
                style="max-width: initial;"
            )
            img(
                v-else
                src="@/assets/coming-soon.jpg"
                class="w-full rounded"
                style="max-width: initial;"
            )
            div(class="absolute top-0 right-0")
                div(class="flex space-x-1 h-[26px]")
                    div(
                        v-if="listing.badgeText"
                        class="or-product-listing-special-tag bg-danger-dark px-2 flex items-center"
                    ) {{ listing.badgeText }}
                    div(
                        v-else-if="listing.isPreOrder"
                        class="or-product-listing-pre-order-tag bg-info px-2 flex items-center"
                    ) PRE-ORDER
                    div(
                        v-else-if="listing.isNew"
                        class="or-product-listing-new-tag bg-info px-2 flex items-center"
                    ) NEW ITEM
                    MadeByRealtruck(
                        v-if="listing.brand && $config.runtime.theme.madeByRealtruck.enabled"
                        :brand="listing.brand"
                        :isJustR="true"
                    )
        //- Title/Price/Stars
        div(class="pt-4 px-2")
            div(
                v-html="listing.productLineName"
                class="leading-5 text-black text-lg font-bold min-h-[50px]"
            )
            div(:class="{'flex flex-col text-sm md:items-center md:flex-row lg:flex-wrap':$config.runtime.theme.priceLabel}")
                span(
                    v-if="listing.hasDiscount"
                    class="or-product-listing-sale-price text-danger font-bold"
                ) Sale:&nbsp;&nbsp;
                span(
                    v-else
                    class="text-gray-darkest"
                ) From:&nbsp;&nbsp;
                span(
                    :data-discount="listing.hasDiscount"
                    class="text-gray-darkest text-base md:text-2xl font-bold"
                    :class="{ 'or-product-listing-sale-price text-danger' : listing.hasDiscount }"
                ) {{ formatCents(listing.salePrice) }}

            div(
                class="flex flex-wrap items-center relative"
            )
                Stars(
                    :averageRating="listing.averageRating"
                    :totalReviews="listing.totalReviews"
                    class="mr-2 py-2"
                )
                template(v-if="$config.runtime.theme.sameDayShipping.enabled && listing.sameDayShipping")
                    Tooltip(
                        mode="hover"
                        text="This product may ship the same day, depending on your vehicle."
                        :hoverDelay="750"
                    )
                        SameDayShippingLogo(class="py-1 w-24")

        AffirmAsLowAs(
            v-if="$affirm.enabled && showAffirm"
            :key="`${listing.productId}-${listing.salePrice}`"
            :price="listing.salePrice"
            pageType="product"
            class="px-2 pb-2 lg:px-0"
        )

        script(v-if="isSchemaOn" type="application/ld+json" v-html="getSchema(listing)")
</template>

<script>
import ProductListing from '@/components/productListing'

export default {
    name: 'Listing',
    extends: ProductListing,
}
</script>

<style lang="stylus" scoped>
.image-background
    background: radial-gradient(50% 50% at center, rgba(55, 62, 62, 0.00) 50%, rgba(55, 62, 62, 0.01) 74%, rgba(55, 62, 62, 0.05) 100%)
</style>
